export default [
  {
    "x": 22.5078941,
    "y": 15.497079,
    "angle": -0.7625960276469583,
    "lengthA": 22.410024284418206,
    "lengthB": 3.992738311340432
  },
  {
    "x": 23.2035451,
    "y": 41.4212219,
    "angle": -2.6581301889179745,
    "lengthA": 15.22824846955464,
    "lengthB": 2.1815356471505423
  },
  {
    "x": 16.9194333,
    "y": 58.6084455,
    "angle": -1.357439560988492,
    "lengthA": 4.396564419276203,
    "lengthB": 5.1190916167526845
  },
  {
    "x": 15.1861191,
    "y": 67.3095379,
    "angle": -1.5707963267948966,
    "lengthA": 3.713117099999998,
    "lengthB": 3.7131171999999992
  },
  {
    "x": 0,
    "y": 100.261561,
    "angle": -1.5707963267948966,
    "lengthA": 15.360521199999994,
    "lengthB": 5.938034999999999
  },
  {
    "x": 13.6688636,
    "y": 107.119021,
    "angle": -1.5707963267948966,
    "lengthA": 0.9194240000000065,
    "lengthB": 12.158889000000002
  },
  {
    "x": 20.4213914,
    "y": 150.404328,
    "angle": -2.2391712753788955,
    "lengthA": 12.8131187845811,
    "lengthB": 6.61292816416121
  },
  {
    "x": 57.6566773,
    "y": 154.546075,
    "angle": -2.2766510486292204,
    "lengthA": 1.2552207216797757,
    "lengthB": 2.0535440129321243
  },
  {
    "x": 58.9887794,
    "y": 183.448736,
    "angle": -2.7830954643499073,
    "lengthA": 2.3106424021753553,
    "lengthB": 4.423694129504956
  },
  {
    "x": 119.846712,
    "y": 185.000867,
    "angle": 2.216568350078453,
    "lengthA": 4.7088559419037255,
    "lengthB": 2.37765833118322
  },
  {
    "x": 116.81317,
    "y": 133.225203,
    "angle": 1.6325145694526557,
    "lengthA": 1.097146930727598,
    "lengthB": 8.706310514148043
  },
  {
    "x": 155.999176,
    "y": 67.026796,
    "angle": 1.576080446844857,
    "lengthA": 39.32593602663479,
    "lengthB": 4.0262249105303916
  },
  {
    "x": 148.030266,
    "y": 32.1546456,
    "angle": 0.954405609676833,
    "lengthA": 11.356512151211804,
    "lengthB": 11.356512151211826
  },
  {
    "x": 106.634429,
    "y": 1.45127727,
    "angle": 0.07929303671039159,
    "lengthA": 26.907621987284177,
    "lengthB": 2.454901415511685
  },
  {
    "x": 88.6555913,
    "y": 9.83711828,
    "angle": -0.08953717688987052,
    "lengthA": 7.071067812244373,
    "lengthB": 7.071067810456007
  },
  {
    "x": 87.8738082,
    "y": 0.000771572442,
    "angle": 0.004138450107563134,
    "lengthA": 3.731931457918934,
    "lengthB": 2.2305048004940966
  }
]
